import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SunSetting01 = function SunSetting01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M12 3v2M5.3141 7.3141 3.9 5.9m14.7859 1.4142L20.1 5.9M6 15c0-3.3137 2.6863-6 6-6s6 2.6863 6 6m4 0H2m17 4H5"
    })
  }));
};
export default SunSetting01;